const initialState = {}

const updatedPlayerReservations = (player_reservations, pr) => {
  const index = player_reservations.findIndex(e => e.id == pr.id)
  return [
    ...player_reservations.slice(0, index), 
    pr,
    ...player_reservations.slice(index + 1, player_reservations.length)
  ]
}

const updatedDrops = (drops, payload) => {
  if (!drops) return

  const newDrops = drops.map(drop => {
    if (drop.player_id == payload.id) {
      return {...drop, player: `${payload.first_name} ${payload.last_name}`, phone: payload.phone}
    } else { return drop }
  })

  return [...newDrops]
}

const appendedNotes = (notes, note) => {
  return [ note, ...notes ]
}

const updatedNotes = (notes, note) => {
  const index = notes.findIndex(n => n.id == note.id)
  return [
    ...notes.slice(0, index), 
    note,
    ...notes.slice(index + 1, notes.length)
  ]
}

const releasedNotes = (notes, noteId) => {
  const index = notes.findIndex(n => n.id == noteId)
  return [
    ...notes.slice(0, index), 
    ...notes.slice(index + 1, notes.length)
  ]
}

const updatedDrop = (drops, drop) => {
  const index = drops.findIndex(d => d.id == drop.id)
  return [
    ...drops.slice(0, index),
    drop,
    ...drops.slice(index + 1, drops.length)
  ]
}

const splitDrops = (drops, slicedDrops) => {
  var newDrops = drops
  if (!slicedDrops) return
  slicedDrops.drops.forEach((drop) => {
    if (newDrops.findIndex(d => d.id == drop.id) != -1) newDrops = updatedDrop(newDrops, drop)
    else newDrops.push(drop)
  })

  if (slicedDrops.deleted) {
    const index = newDrops.findIndex(drop => drop.id == slicedDrops.deleted)
    if (index != -1) newDrops = [...newDrops.slice(0, index),
      ...newDrops.slice(index + 1, newDrops.length)]
  }

  newDrops.sort((a, b)=> a.time >= b.time ? 1 : -1)

  return [...newDrops]
}

const updatedGame = (game, data) => {
  const updatedGame = {
    number_of_players: data.number_of_players, 
    balance: data.balance,
    expected_revenue: data.expected_revenue
  }
  return {...game, ...updatedGame}
}

const openGameModal = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'OPEN_GAME_MODAL.GAME_LOADED':
      return {...state, ...payload}
    case 'OPEN_GAME_MODAL.CLEAR_GAME':
      return initialState
    case 'OPEN_GAME_MODAL.CHANGE_PLAYERS_COUNT':
      const newGame = {...state.game, number_of_players: payload.count}
      return {...state, game: newGame}
    case 'OPEN_GAME_MODAL.PR_CHANGED':
      return {...state, player_reservations: updatedPlayerReservations(state.player_reservations, payload)}
    case 'OPEN_GAME_MODAL.ROASTER_CHANGED':
      return {...state, game: updatedGame(state.game, payload.game), player_reservations: payload.player_reservations}
    case 'OPEN_GAME_MODAL.NOTE_CREATED':
      return {...state, notes: appendedNotes(state.notes, payload)}
    case 'OPEN_GAME_MODAL.NOTE_EDITED':
      return {...state, notes: updatedNotes(state.notes, payload)}
    case 'OPEN_GAME_MODAL.NOTE_DELETED':
      return {...state, notes: releasedNotes(state.notes, payload)}
    case 'OPEN_GAME_MODAL.DROPS_UPDATED':
      return {...state, drops: splitDrops(state.drops, payload)}
    case 'OPEN_GAME_MODAL.SHOW_ALERT':
      return {...state, alert: payload}
    case 'OPEN_GAME_MODAL.CLEAR_ALERT':
      if (_.isEmpty(state)) return state

      return {...state, alert: null}
    case 'OPEN_GAME_MODAL.UPDATE_PLAYER':
      const index = state.player_reservations.findIndex(e => e.player_id == payload.id)
      if (index === -1) return {...state, drops: updatedDrops(state.drops, payload)}
      const pr = state.player_reservations[index]
      const newPr = { ...pr, name: payload.name, displayed_name: payload.display_name, player_captain: payload.captain }
      if (!payload.captain && pr.is_game_captain) newPr.is_game_captain = false
      return {...state, drops: updatedDrops(state.drops, payload), player_reservations: updatedPlayerReservations(state.player_reservations, newPr)}
    case 'OPEN_GAME_MODAL.SET_REFRESH_FUNC':
      return {...state, refreshFunc: () => payload()}
    case 'OPEN_GAME_MODAL.START_PAYMENT':
      return {...state, payment: payload}
    case 'OPEN_GAME_MODAL.CLEAR_PAYMENT':
      return {...state, payment: null}
    case 'OPEN_GAME_MODAL.REFRESH_GAME':
      if (_.isEmpty(state)) break
      return {...state, game: {...state.game, ...payload.game},
                        player_reservations: payload.player_reservations, 
                        alert: { 'text': 'Open game updated', 'type': 'success' }
             }
    case 'PAYMENT_SUCCESS':
      if (_.isEmpty(state)) return state
      
      return {
        ...state,
        game: payload.game,
        player_reservations: updatedPlayerReservations(state.player_reservations, payload.player_reservation),
        payment: null,
        alert: { text: payload.message, type: 'success' }
      }
    case 'PROCESS_ALL_PAYMENTS':
      return {
        ...state,
        game: {...state.game, ...payload.game},
        player_reservations: payload.player_reservations
      }
    case 'OPEN_GAME_MODAL.UPDATE_GAME_CHANNEL':
      return {...state, game: {...state.game, ...{ channel_id: payload }}}
    case 'OPEN_GAME_MODAL.SET_EVENTS':
      return {...state, events: payload}
    case 'OPEN_GAME_MODAL.SET_NOTES':
      return {...state, notes: payload}
    case 'OPEN_GAME_MODAL.SET_REVIEWS':
      return {...state, reviews: payload}
    case 'OPEN_GAME_MODAL.SET_DROPS':
      return {...state, drops: payload}
    case 'OPEN_GAME_MODAL.SET_GAME_DETAILS_LOADING':
      return {...state, gameDetailsLoading: payload}
    case 'OPEN_GAME_MODAL.SET_WAITING_PLAYERS':
      state.refreshFunc()
      return {...state, waiting_players: payload}
    }
  return state
}

export default openGameModal
